import GLEntityTable from "./GLEntityTable";

const GLEntity = () => {
  return (
    <>
      <GLEntityTable />
    </>
  );
};

export default GLEntity;
